<template>
    <div :class="one ? 'container containerNew' : 'container'">
        <div class="common-header-wrap">
            <mt-header :title="$t('hunt16')" class="common-header">
                <mt-button slot="left" icon="back" @click="one ? onPage('index') : $router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="notes">
            <div class="notes_box" v-for="el in list" :key="el.id">
                <!-- <img src="../../../assets/image/one/hunt_notes.png" alt=""> -->
                <div class="notes_box_le">
                    <img src="@/assets/image/one/xiao.png" alt="">
                </div>
                <div class="notes_box_ri">
                    <div>{{ el.phase_sn }}</div>
                    <div>{{$t('hunt61')}}{{ el.slots }}{{$t('hunt62')}} </div>
                    <div @click="getGMM(el.activity_id)">{{$t('hunt63')}}</div>
                </div>
            </div>
            <div class="more" v-if="(page * limit) < BuyList.total" @click="more">{{ $t('yi21') }}</div>
        </div>



        <van-popup v-model="show"  class="newDialog">
            <div class="title_x" @click="show = !show">
                <svg t="1732585927904" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    p-id="6277" data-spm-anchor-id="a313x.search_index.0.i8.51fd3a819BMxuG" width="200" height="200">
                    <path
                        d="M512 128c211.2 0 384 172.8 384 384s-172.8 384-384 384-384-172.8-384-384 172.8-384 384-384m0-64C262.4 64 64 262.4 64 512s198.4 448 448 448 448-198.4 448-448-198.4-448-448-448z"
                        fill="#999999" p-id="6278" data-spm-anchor-id="a313x.search_index.0.i7.51fd3a819BMxuG"
                        class="selected"></path>
                    <path
                        d="M646.4 332.8L512 467.2 377.6 332.8c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8L467.2 512l-134.4 134.4c-12.8 12.8-12.8 32 0 44.8s32 12.8 44.8 0L512 556.8l134.4 134.4c12.8 12.8 32 12.8 44.8 0s12.8-32 0-44.8L556.8 512l134.4-134.4c12.8-12.8 12.8-32 0-44.8s-32-12.8-44.8 0z"
                        fill="#999999" p-id="6279" data-spm-anchor-id="a313x.search_index.0.i10.51fd3a819BMxuG"
                        class="selected"></path>
                </svg>
            </div>

            <div class="slay_buy flex">
                <div class="slay_buy_le">
                    {{$t('hunt64')}}
                </div>
                <div class="slay_buy_ri">
                    <span v-for="(el, i) in BuyListNew.data" :key="i">{{ el.lottery_number }}</span>
                </div>
            </div>
        </van-popup>
    </div>
</template>


<script>
import { BuyRecords, MyBuyNumberList } from '../../../api/memberOne'
export default {
    name: 'HuntNotes',
    data() {
        return {
            page: 1,
            limit: 10,
            BuyList: [],
            list: [],
            show: false,
            BuyListNew: [],
        }
    },
    props: {
        one: {
            default: false,
            type: Boolean
        },
    },
    created(){
        this.getBuyRecords()
    },
    methods: {
        more(){
            this.page++
            this.getBuyRecords()
        },
        onPage(v, val) {
            this.$emit('onPage', v, val)
        },
        goNav(name = 'HuntIndex', val){
            this.$router.push({ name: name, query: { data: val }  })
        },
        getBuyRecords(){
            const { page, limit, list } = this
            BuyRecords({
                page,
                limit
            }, 'one').then(res=>{
                if (res && res.result) {
                    this.BuyList = res.result
                    list.push(...res.result.data)
                }
            })
        },
        getGMM(id){
            this.BuyList = []
            this.getBuyList(id)
            this.show = true
        },
        getBuyList(id){
            MyBuyNumberList({
                activity_id: id,
                page:1,
                limit: 1000
            }, 'one').then(res=>{
                if (res && res.result) {
                    this.BuyListNew = res.result
                }
            })
        }
    }
}
</script>


<style lang="scss" scoped>
.containerNew{
    height: 100% !important;
}
.container{
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    .flex{
        display: flex;
    }
    .notes{
        overflow-y: auto;
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 17px 4px 20px;
        box-sizing: border-box;
        
        .notes_box{
            display: flex;
            margin-bottom: 10px;
            box-shadow: 0px 5px 5px 0px rgba(254,109,98,0.1);
            box-sizing: border-box;
            position: relative;

            &::before {
                content: "";
                position: absolute;
                top: -7.5px;
                left: 125px;
                width: 15px;
                height: 15px;
                background: #F6F5F8;
                border-radius: 50%;
                z-index: 2;
            }
            &::after {
                content: "";
                position: absolute;
                bottom: -7.5px;
                left: 125px;
                width: 15px;
                height: 15px;
                background: #F6F5F8;
                border-radius: 50%;
                z-index: 1;
            }
            .notes_box_le{
                background: #FEB35C;
                border-radius: 10px 0 0 10px;
                padding: 10px;
                box-sizing: border-box;
                img{
                    width: 110px;
                    height: auto;
                }
            }
            .notes_box_ri{
                background: #fff;
                // position: absolute;
                // left: 40%;
                border-radius: 0 10px 10px 0;
                flex: 1;
                // width: 55%;
                // margin-left: 40%;
                height: 100%;
                padding: 5px 10px 10px;
                box-sizing: border-box;
                // background: rgba(0,0,0,.1);
                font-size: 16px;
                color: #333333;
                z-index: 1; 
                // max-width: 58%;
                overflow: hidden;
                // display: flex;
                // flex-direction: column;
                // justify-content: space-between;
                div:nth-child(1){
                    border-bottom: #DFDFDF 1px solid;
                    // padding-bottom: 5px;
                    font-weight: bold;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 2;
                    overflow-wrap: break-word;
                    white-space: normal;
                    min-height: 30px;
                    // line-height: 12px;
                }
                div:nth-child(2){
                    padding: 5px 0;
                }
                div:nth-child(3){
                    // padding: 8px 12px;
                    // border: #FE3420 1px solid;
                    // border-radius: 15px;
                    // display: inline-block;

                    padding: 5px 10px;
                    border: 1px solid #fe3420;
                    border-radius: 8px;
                    display: inline-block;
                    font-size: 12px;
                }
            }
        }
    }
    .more{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        text-align: center;
        padding: 10px 0;
        border-radius: 20px;
        border: 1px solid #FE3421;
        font-size: 16px;
        color: #FE3421;
    }
    .newDialog{
        width: 80%;
        max-width: 300px;
        max-height: 50%;
        min-height: 200px;
        border: 1px solid #B15E3C;
        border-radius: 6px;
        padding: 50px 16px 16px;
        background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        .title_x {
            width: 20px;
            height: 20px;
            position: absolute;
            top: 16px;
            right: 16px;

            svg {
                width: 20px;
                height: 20px;
            }
        }
        .slay_buy {
            width: 100%;
            flex: 1;
            justify-content: space-between;
            overflow-y: auto;
            flex-direction: column;

            .slay_buy_le {
                font-weight: bold;
                font-size: 16px;
                color: #000;
            }

            .slay_buy_ri {
                color: #EA1D10;
                margin-left: 10px;
                flex: 1;
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-row-gap: 10px; /* 每行间距 40px */
            }
        }
    }
}
</style>
